<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-title class="text-h5 mx-8">
          {{ entityN }}
        </v-card-title>
        <v-card-text>
          <v-row
            class="text-center mx-auto m-center"
            v-for="products in getAllCategoryProductToDisplay"
            :key="products"
          >
            <v-col
              class="mt-5 text-justify mt-n4 mb-n2"
              cols="12"
              xs="12"
              sm="12"
              md="6"
              lg="6"
              v-for="product in products.products"
              :key="product"
            >
              <v-card
                class="ma-2"
                style="box-shadow: 0 4px 1px -3px #0000000d, 0 0 0 0 #00000000, 0 1px 5px 0 #00000008; background-color: #f6f6f6"
                @click="
                  openWindowPay(
                    product.productPrice,
                    product.productName,
                    entityN,
                    entityUuid,
                    product.productUUID,
                    products.productCategoryName,
                    products.productCategoryUUID,
                    product.productCodeExternal,
                  )
                "
              >
                <v-card-text class="blue-grey--text">
                  <span>
                    <v-avatar size="40">
                      <v-icon color="blue-grey">mdi-format-list-checks</v-icon>
                    </v-avatar>
                    <span
                      class="ml-3"
                      style="font-size: 12px; text-transform: uppercase"
                    >
                      {{
                        product.productName.length > 20
                          ? product.productName.substring(0, 14)
                          : product.productName
                      }}{{product.productCodeExternal ? ' - ' + product.productPrice + ' AKZ' : ""}}
                    </span>
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-card-text>
              <v-text-field
                v-if="
                  products.productCategoryName.toUpperCase() ===
                    'RECARGAS DIRECTAS' &&
                    entityN.toUpperCase() === 'AGENTE RECARGAS SYS FACTORY'
                "
                class="ma-1"
                v-model="recharge"
                label="Nº de telefone a carregar"
                required
                filled
                :rules="rechargeRules"
              ></v-text-field>
            </v-card-text>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold blue-grey--text mr-10"
            text
            @click="dialogClose"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import eventBus from "../../../../main";
import { mapHelper } from "@/store/helper";
export default {
  name: "ListCProductCategory",
  data: () => ({
    dialog: false,
    entityN: "",
    category: "",
    entityUuid: "",
    recharge: "",
    description: "",
    rechargeRules: [
      v => !!v || "Telefone é requerido",
      v => /^[9]+[1-9]\d{7}$/.test(v) || "Telefone inválido"
    ]
  }),
  methods: {
    dialogClose() {
      this.dialog = false;
    },
    openWindowPay(
      price,
      product,
      entityName,
      origin,
      productUUID,
      productCategoryName,
      productCategoryUUID,
      ProductCodeExternal,
    ) {

      let payloadEntity = {
        open: true,
        price: price,
        product: product,
        entity: entityName,
        refOrigin: origin,
        productUUID: productUUID,
        productCategoryName: productCategoryName,
        productCategoryUUID: productCategoryUUID,
        recharge: this.recharge ? this.recharge : "NBO",
        description: this.description
      };
      let off = {
        open: false,
        entity: "payload.entity",
        entityUuid: "",
        productCategoryUUID: ""
      };
      let Reg = /^[9]+[1-9]\d{7}$/;
      let RegVerify = Reg.test(this.recharge);
      if (
        payloadEntity.productCategoryName.toUpperCase() ===
          "RECARGAS DIRECTAS" &&
        this.entityN.toUpperCase() === "AGENTE RECARGAS SYS FACTORY" &&
        RegVerify === false
      ) {
        this.recharge = "Para que número deseja carregar ?";
        return false;
      }

      if (
        payloadEntity.productCategoryName.toUpperCase() ===
          "RECARGAS DIRECTAS" &&
        this.entityN.toUpperCase() === "AGENTE RECARGAS SYS FACTORY" &&
        RegVerify === true
      ) {
        // ProductCodeExternal
        let description =
          price + "SYS" + ProductCodeExternal + "SYS" + this.recharge;
        // let description = ProductCodeExternal + "SYS" + this.recharge;

        this.$store.dispatch("saveReference", description);
      }

      eventBus.$emit("openWpayment", true); // emit the event to the bus
      eventBus.$emit("listCProductCategory", off); // emit the event to the bus

      this.$store.dispatch("setBuyerEntity", payloadEntity);
    }
  },
  created() {
    const self = this;
    eventBus.$on("listCProductCategory", function(payload) {
      self.dialog = payload.open;
      self.entityN = payload.entity;
      self.entityUuid = payload.entityUuid;
      self.category = payload.productCategoryUUID;
    });
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped></style>
